import styled from 'styled-components';
import { createGradientOrSolid } from 'utils/index';
import { breakpoints } from 'styles/breakpoints';

export const StyledFrame = styled.div`
  background: var(--bundle-border-color);
  padding: 1px;
  border-radius: 8px;
  min-width: 300px;
  max-width: 400px;
  min-height: 189px;
  width: 100%;
  font-family: var(--font-family), Arial;

  .price-container {
    width: 132px;
    height: 24px;
    position: relative;
    margin-top: auto;

    .price {
      border: 1px solid #24e93b;
      width: 132px;
      height: 24px;
      border-radius: 16px;
      font-size: inherit;
      position: relative;

      &:before {
        content: '';
        width: 124px;
        height: 12px;
        background: rgba(255, 255, 255, 0.4);
        position: absolute;
        border-radius: 16px;
        top: 1px;
      }

      .totalPrice {
        align-items: center;
        padding: 0 8px;
        position: relative;

        .final-price {
          text-shadow: -1px -1px 0 #0b7d00, 1px -1px 0 #0b7d00,
            -1px 1px 0 #0b7d00, 1px 1px 0 #0b7d00;
          font-weight: 950;
          font-size: inherit;
        }

        .stroked {
          color: #fff;
          font-size: 8px;
          font-style: normal;
          font-weight: 950;
          line-height: normal;
          text-decoration-thickness: 1px;
          text-decoration-color: #d70000;

          text-shadow: 0 1.166px 1.166px rgba(0, 0, 0, 0.6);
        }
      }
    }
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    min-height: 189px;

    .price-container {
      width: 152px;
      height: 28px;

      .price {
        width: 152px;
        height: 28px;
        font-size: inherit;

        .totalPrice {
          .stroked {
            font-size: 10px;
          }
        }
      }
    }
  }
` as any;

export const StyledSpecialOffer = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  font-family: var(--font-family), Arial;
  position: relative;

  .ghost-emblem {
    position: absolute;
    top: 9px;
    left: 9%;
    width: 56px;
    height: 56px;
    z-index: 1;

    &--badge {
      width: 56px;
      height: 56px;
      object-fit: contain;
    }
  }

  .frame {
    height: 100%;
    width: 100%;
    min-height: 120px;
    position: relative;
    background: ${(props: any) =>
      props.backgroundImage
        ? `url("${props.backgroundImage}")`
        : createGradientOrSolid(props.backgroundColor)};
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 6px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
  }

  .timeLeft {
    font-size: 12px;
    font-style: normal;
    font-weight: 950;
    line-height: normal;
    color: #fff;
    position: absolute;
    left: 6px;
    bottom: 8px;
  }

  .availability {
    font-size: 12px;
    font-style: normal;
    font-weight: 950;
    line-height: normal;
    color: #fff;
    position: absolute;
    right: 6px;
    bottom: 8px;
  }

  @media only screen and (min-width: ${breakpoints.desktop}) {
    height: 100%;

    .frame {
      padding: 8px;
    }

    .timeLeft {
      font-size: 14px;
    }

    .availability {
      font-size: 14px;
    }
  }
` as any;

export const ProductsBackground = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 100%;
  height: 80px;
  margin-top: 65px;
  padding: 0 40px;
` as any;

export const StylesGhostPromotionSaleBadge = styled.div`
  position: absolute;
  z-index: 15;
  top: 14px;
  right: 10%;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;

  .ghost-promotion-sale-badge {
    &--container {
      position: relative;
      width: 25px;
      height: 25px;

      .ghost-promotion-sale-badge {
        &--image {
          width: 100%;
          height: 100%;
          max-height: 25px;
          object-fit: contain;
        }

        &--number {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 5px;
          font-weight: 950;
          text-align: center;
          font-style: normal;

          &-text {
            text-transform: uppercase;
          }
        }
      }
    }
  }
`;
